module.exports = __webpack_public_path__ + "static/media/hshs.6307f372.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/hshs.png
// module id = 336
// module chunks = 0